export default __webpack_public_path__ + "static/media/no-mistakes-illustration-blob-bottom.197b699d.svg";